// Module
var code = "<div class=\"panel panel-default\"> <div class=\"panel-heading\" ng-show=\"tocHeading\"> <h3 class=\"panel-title\"> {{tocHeading}} </h3> </div> <div class=\"panel-body\"> <div class=\"{{heading.depth}}\" ng-repeat=\"heading in toc\"> <a href=\"#{{heading.target}}\">{{heading.text}}</a> </div> </div> </div> ";
// Exports
module.exports = code;